







































import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      mfaCode: "",
    };
  },
  methods: {
    verifyMFACode() {
      this.$validator.validateAll().then((result) => {
        this.$emit("verifyMFACode", this.mfaCode);
      });
    },
    resendMFACode() {
      this.$emit("resendMFACode");
    },
  },
});
